import _ from '../utils'
import FORM_FILE_CONFIG from './config'

class FormFileClass {
    constructor( el ) {
        this.DOM = {
            el: el,
            input: _.select( 'input[type="file"]', el ),
            output: _.select( '.file__output ul', el ),
            delete: _.select( '.file__delete', el )
        }

        this.init()
    }

    init() {
        this._listeners()
    }

    _listeners() {
        this.DOM.input.addEventListener( 'change', this._upload.bind( this ) )
        this.DOM.delete.addEventListener( 'click', this._delete.bind( this ) )
    }

    _upload() {
        this.DOM.output.innerHTML = ''

        let fileName = this.DOM.input.files[0].name,
            li = document.createElement( 'li' )

        li.innerHTML = `
        <span>${fileName}</span>
        `
        this.DOM.output.appendChild( li )

        // Show file uploaded
        _.addClass( this.DOM.el, 'is--file' )
        
    }

    _delete() {
        // Hide file uploaded
        _.removeClass( this.DOM.el, 'is--file' )
        this.DOM.output.innerHTML = ''

        this.DOM.input.value = null
    }
    
}

const FORM_FILES = []
FORM_FILE_CONFIG.els.forEach( ( el ) => { new FormFileClass( el ) })